module.exports = __webpack_public_path__ + "static/img/6.fccb65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/6.png
// module id = WQ33
// module chunks = 1